import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCharacterInfo } from "../../api/fetchCharacterInfo";
import { addCharacterInfo } from "../../api/addCharacterInfo";

const initialState = {
  data: null
};

// Thunk for fetching character info
export const fetchCharacterData = createAsyncThunk(
  "characterInfo/fetchCharacterData",
  async (comicId, { rejectWithValue }) => {
    try {
      const response = await fetchCharacterInfo(comicId);
      return response;
    } catch (error) {
      console.error("Error fetching character data:", error);
      return rejectWithValue(error.toString());
    }
  }
);

// Thunk for adding a new character
export const addCharacter = createAsyncThunk(
  "characterInfo/addCharacter",
  async ({ comicId, character }, { rejectWithValue }) => {
    try {
      const response = await addCharacterInfo(comicId, character);
      return response;
    } catch (error) {
      console.error("Error adding character:", error);
      return rejectWithValue(error.toString());
    }
  }
);

const characterInfoSlice = createSlice({
  name: "characterInfo",
  initialState,
  reducers: {
    resetCharacterInfo: (state) => {
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // We only need to handle the fulfilled cases since that's all we use
      .addCase(fetchCharacterData.fulfilled, (state, action) => {
        state.data = action.payload;
      })
      .addCase(addCharacter.fulfilled, (state, action) => {
        state.data = action.payload;
      });
  }
});

// Export reducer's actions
export const { resetCharacterInfo } = characterInfoSlice.actions;

// Export selectors
export const selectCharacterData = (state) => state.characterInfo.data;

// Export reducer
export default characterInfoSlice.reducer;
